import React, { useEffect, useState } from 'react'
import { BottomContainer, ChallengeDetailsConatainer, ColorBox, LevelConatiner } from '../../UserDashboard/styles'
import { DateContainer, JournalContainer, NoJournalContainer, TaskCalendar, TextContainer } from './styles'
import { useParams } from "react-router-dom";
import { GetJournalData, GetJournalEntryByDate, GetWellnessChallengeDetails } from '../../../redux/constants/apiConstants';
import { fetchApi } from '../../../utils/methods';
import { toast } from 'react-toastify';
import { CalendarPicker, CalendarWrapper } from '../../LogWorkoutCategoryV3/styles';
import Calendar from 'react-calendar';
import moment from 'moment';
import SubmitJournalModal from './SubmitJournalModal';
import parse from 'react-html-parser';
import { AddIconBranding } from '../../../utils/icons';
import {feelingsData} from "../../../../mockData";





function JournalDetailsPage() {

  const { id } = useParams();
  const[loading, setLoading]= useState(true);
  const[dataLoading, setDataLoading]= useState(true);
  const[journalData, setJournalData]=useState([]);
  const [wellnessChallengeDetails, setWellnessChallengeDetails] = useState(null);
  const [selectedDate, setSelectedDate] = useState(null);
  const [journalDetails, setJournalDetails] = useState(null);
  // const [isJournalData, setIsJournalData] = useState(null);
  const [showReflectPopup, setShowReflectPopup] = useState(false);

  window.console.log("challengeid", id, dataLoading);
  window.console.log("challengeid",journalData, loading);

  useEffect(()=>{

    if (id) {
      fetchJournalData(id);
      FetchWellnessChallenegesData(id);
    }
   
  },[]);



  const FetchWellnessChallenegesData = async (challengeId) => {
    setDataLoading(true);
    try {
      const res = await fetchApi(GetWellnessChallengeDetails + "/" + challengeId, "GET");
      window.console.log("wellness challenge details", res)
      if (res.status === 'success') {
        setWellnessChallengeDetails(res.data);

        const start = moment(res.data.challenge_info.challenge_started_at);
        const end = moment(res.data.challenge_info.challenge_end_at);
        const today = moment();
      
        let defaultDate;
      
        if (today.isBetween(start, end, "day", "[]")) {
          defaultDate = today.toDate();
        } else {
          defaultDate = start.toDate();
        }
      
        setSelectedDate(defaultDate);
        await handleDayClick(defaultDate);
       

      } else {
        toast.error((res?.data?.message))
      }
    } catch (error) {
      window.console.error(error);
    }
    finally {
      setDataLoading(false);  
    }
  }


  const fetchJournalData = async(challengeId)=>{
    setLoading(true);
    try{
      const res = await fetchApi(GetJournalData + '/' + challengeId);
      if(res.status === 'success'){
        setJournalData(res?.data)
        setLoading(false);
      }else{
        toast.error(res?.data?.message);
        setLoading(false);
      }
    }catch(error){
      window.console.log("error",error);
      setLoading(false);
    }
  }


  const handleDayClick = async(day)=>{
    setSelectedDate(day);
    const formattedDate = moment(day).format("YYYY-MM-DD");

    setLoading(true);
    try{
      const res = await fetchApi(GetJournalEntryByDate + '/' + id + '/' + formattedDate);
      if(res.status === 'success'){
        // const journalArray = res?.data?.journal_entry || [];
        // setIsJournalData(res?.data)
        // const data = res?.data?.[0];


        if (res?.data) {
          setJournalDetails(res?.data);   
          // setShowReflectPopup(false);
        } else {
          setJournalDetails(null);             
          // setShowReflectPopup(true);          
        }
        setLoading(false);
      }else{
        toast.error(res?.data?.message);
        setLoading(false);
      }
    }catch(error){
      window.console.log("error",error);
      setLoading(false);
    }
  }



  const SkeletonLoader = () => {
    window.console.log("")
    return (
      <ChallengeDetailsConatainer style={{gap:"16px"}}>
        <div style={{
          width: "60%",
          height: "200px",
          background: "#eee",
          borderRadius: "8px",
          animation: "pulse 1.5s infinite"
        }} />
  
        <div style={{
          width: "40%",
          height: "400px",
          background: "#eee",
          borderRadius: "8px",
          animation: "pulse 1.5s infinite"
        }} />
      </ChallengeDetailsConatainer>
    );
  };



  const getFeelingEmoji = (feeling) => {
    window.console.log("")
    return feelingsData.find((f) => f.id === feeling)?.emoji || "🙂";
  };



  const CalendarView = () => {

    const startDate = moment(
      wellnessChallengeDetails?.challenge_info?.challenge_started_at
    );
  
    const endDate = moment(
      wellnessChallengeDetails?.challenge_info?.challenge_end_at
    );
  
    const isOutsideRange = (date) => {
      window.console.log("")
      return (
        moment(date).isBefore(startDate, "day") ||
        moment(date).isAfter(endDate, "day")
      );
    };
  
    const getJournalStatus = (date) => {
      window.console.log("")
      return journalData.find((item) =>
        moment(item.date).isSame(date, "day")
      );
    };
  
    return (
      <CalendarWrapper>
        <CalendarPicker>
          <TaskCalendar>
            <Calendar
              value={selectedDate}
              onChange={handleDayClick}
              // onChange={setSelectedDate}
              prevLabel={null}
              nextLabel={null}
              prev2Label={null}
              next2Label={null}
              navigationLabel={null}
              minDate={startDate.toDate()}
              maxDate={endDate.toDate()}
              formatShortWeekday={(locale, date) =>
                date.toLocaleDateString(locale, { weekday: "short" }).slice(0, 2)
              }
  
              tileClassName={({ date, view }) => {
                if (view !== "month") return null;


                // ❌ Outside range → grey
                if (isOutsideRange(date)) return "na";
                
                const today = moment();
                // ⚠️ Future BUT inside challenge → light grey (#F8F8F8)
                if (moment(date).isAfter(today, "day")) {
                  return "future";
                }
  
  
                const journal = getJournalStatus(date);
  
                let className = "";
  
                if (journal) {
                  // ✅ GREEN if journal added
                  if (journal.has_added_journal_for_day) {
                    className = "completed"; // green
                  } else {
                    className = "missed"; // red
                  }
                }
  
                // ✅ selected
                if (selectedDate && moment(date).isSame(selectedDate, "day")) {
                  className += " selected";
                }
  
                return className.trim();
              }}

              tileDisabled={({ date }) => {
                const today = moment();
              
                return (
                  isOutsideRange(date) ||
                  moment(date).isAfter(today, "day")   // ✅ disable future
                );
              }}
  
              // tileDisabled={({ date }) => isOutsideRange(date)}
            />
          </TaskCalendar>
        </CalendarPicker>
      </CalendarWrapper>
    );
  };





  if (loading) {
    return <SkeletonLoader />;
  }


  return (
    <ChallengeDetailsConatainer style={{flexDirection:"column"}}>
      <DateContainer>
        {journalDetails?.formatted_date || moment(selectedDate).format("MMMM DD, YYYY")}
      </DateContainer>

      <div style={{display:"flex",gap:"16px", alignItems: "flex-start",marginTop:"12px" }}>

        {journalDetails?.journal_entry[0] ? <JournalContainer>
          <div className="journalContent">
            <div className="feelingIcon">{getFeelingEmoji(journalDetails?.feeling)}</div>
            <div>
              <div>
                <TextContainer isFontSize={"18px"} isLineHeight={"24px"} isFontWeight={"700"} > {journalDetails?.journal_entry[0]?.title}</TextContainer>
              </div>
              <div className="aboutext">
                <TextContainer isFontSize={"18px"} isLineHeight={"24px"} isFontWeight={"400"}>  {parse(journalDetails?.journal_entry[0]?.about_the_day )}</TextContainer>
              </div>
            </div>
          </div>
        </JournalContainer>: 
          <NoJournalContainer>
            <div style={{display:"flex",gap:"16px"}}>
              <div>
                <TextContainer  isFontSize={"18px"} isLineHeight={"24px"} isFontWeight={"700"} >It looks like you haven’t made a journal entry</TextContainer>
                <TextContainer isFontSize={"18px"} isLineHeight={"24px"} isMargin={"8px 0 0 0"} isFontWeight={"400"}>Take a moment to reflect on your day, jot down what you learned, or share your feelings.</TextContainer>
              </div>
              <div className="plusIcon" onClick={() => setShowReflectPopup(true)}>{AddIconBranding()}</div>
            </div>

          </NoJournalContainer>
        }

        <LevelConatiner style={{ display: "block",width:"420px" }}>
          <CalendarView/>
          <BottomContainer isWidthSize={"127px"}>
            <div className="secondRow seconRowMargin">
              <div className="rowContennt">
                <ColorBox />
                <div className="textBox">Completed</div>
              </div>
              <div className="rowContennt">
                <ColorBox isColor="#FDD2CB" />
                <div className="textBoxForNC">Not Completed</div>
              </div>
              <div className="rowContennt">
                <ColorBox isColor="#DCDCDC" />
                <div className="textBox">NA</div>
              </div>
            </div>
          </BottomContainer>
    
        </LevelConatiner>


      </div>

      {showReflectPopup && (
        <SubmitJournalModal   refreshSelectedDate={handleDayClick}    fetchJournalData={fetchJournalData} showModal={showReflectPopup}  onHide={()=>setShowReflectPopup(false)} selectedDate={selectedDate}  challengeId={id} />
      )}
    </ChallengeDetailsConatainer>
  )
}

export default JournalDetailsPage
